import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {setIn} from '@packages/systems/core/utils/ImmUtils';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {generateGuid} from '@packages/utilities/guid';
import {qualify} from '@packages/systems/wfdl-Qualified';
import {ElementPreset, Plugins, Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';

export const setPaginationLimit = setIn(['data', 'pagination', 'limit']);

const horizontalPadding = px(9);
const verticalPadding = px(20);
const horizontalMargin = px(10);
const borderColor = createRgbaColor('cccccc');
const borderWidth = px(1);
const borderRadius = px(2);
const borderStyle = 'solid';

export const paginationButtonInitialStyle = {
  base: {
    main: {
      noPseudo: {
        display: 'block',
        color: createRgbaColor('333333'),
        fontSize: px(14),
        marginLeft: horizontalMargin,
        marginRight: horizontalMargin,
        paddingTop: horizontalPadding,
        paddingBottom: horizontalPadding,
        paddingRight: verticalPadding,
        paddingLeft: verticalPadding,
        backgroundColor: createRgbaColor('fafafa'),
        borderTopWidth: borderWidth,
        borderRightWidth: borderWidth,
        borderBottomWidth: borderWidth,
        borderLeftWidth: borderWidth,
        borderTopColor: borderColor,
        borderRightColor: borderColor,
        borderBottomColor: borderColor,
        borderLeftColor: borderColor,
        borderTopStyle: borderStyle,
        borderRightStyle: borderStyle,
        borderBottomStyle: borderStyle,
        borderLeftStyle: borderStyle,
        borderTopRightRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderBottomLeftRadius: borderRadius,
        borderTopLeftRadius: borderRadius,
      },
    },
  },
} as const;

export const createPaginationElement = (
  plugins: Plugins.PluginsType
): ExpressionElement => {
  const elementPreset = Plugins.getElementPreset(
    plugins,
    qualify(Plugins.name('Pagination'), ElementPreset.name('Pagination'))
  );
  if (elementPreset == null) {
    throw Error('failed to getElementPreset for Pagination');
  }
  const element = Expressions.getElement(
    ElementPreset.instantiateFactory(elementPreset, generateGuid()).element
  );
  if (element === null) {
    throw Error('failed to getElement from pagination factory');
  }
  return element;
};
